module.exports = __webpack_public_path__ + "2cacdf08f4d300de369abf5a24a97f07.mp3";